import React from 'react';
import '../styles/AppHeader.css';

function AppHeader() {
  return (
    <header className="app-header">
      <img src="/logo.png" alt="Lighthouse Hunters" />
    </header>
  );
}

export default AppHeader;
